import { VALID_ATTRIBUTES } from 'mobiledoc-kit/dist/commonjs/mobiledoc-kit/models/markup';
VALID_ATTRIBUTES.push('target');

export { default } from './MobiledocEditor';
